import React, { useEffect } from 'react';
import Helmet from "react-helmet";
import { graphql } from 'gatsby';
import HeaderMain from '../components/HeaderMain';
import Footer from '../components/Footer';
import HeroSingle from '../components/pages/HeroSingle';
// images
import LineFull from '../images/linefull.jpg';
import SEO from '../components/seo';
import '../styles/app.scss';

const SchoolsOut = ({ data }) => {
    const { wordpressPage: post } = data;
    const test_title = post.yoast_title;
    const new_seo_title = test_title.replace('&#039;', "'");
    const schema = {
    "@context": "https://schema.org",
    "@type": "Course",
    "@id": "https://werockthespectrumatlanta.com/classes/#course",
    "name": "Kids Fitness and Enrichment Classes",
    "description": "Book inclusive kids fitness, dance, gymnastics, and enrichment classes at We Rock The Spectrum Kids Gym Atlanta-Roswell. Programs are designed for all children ages 3–12, including neurotypical and neurodiverse learners.",
    "courseMode": "InPerson",
    "provider": {
      "@type": "LocalBusiness",
      "@id": "https://werockthespectrumatlanta.com/#business",
      "name": "We Rock The Spectrum Kids Gym Atlanta-Roswell",
      "description": "Inclusive kids classes and programs for ALL children – neurotypical and neurodiverse together. Social skills, STEAM, arts, music, dance, and life skills programs.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "614 W Crossville Rd",
        "addressLocality": "Roswell",
        "addressRegion": "GA",
        "postalCode": "30075",
        "addressCountry": "US"
      },
      "telephone": "+1-770-680-2535",
      "priceRange": "$35–$495",
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Inclusive Kids Classes and Programs",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Inclusive Children's Programs",
              "description": "Classes including social skills, STEAM, arts, music, dance, and life skills for neurotypical and neurodiverse children.",
              "audience": {
                "@type": "PeopleAudience",
                "suggestedMinAge": 2,
                "suggestedMaxAge": 18
              }
            },
            "priceRange": "$35–$495",
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock"
          }
        ]
      }
    },
    "offers": {
      "@type": "Offer",
      "url": "https://werockthespectrumatlanta.com/classes/",
      "priceCurrency": "USD",
      "price": "27.91",
      "availability": "https://schema.org/InStock",
      "eligibleRegion": {
        "@type": "Place",
        "name": "Roswell, Georgia"
      }
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "132"
    }
  };
    useEffect(() => {
        const observeWidgetChanges = () => {
            const widgetContainer = document.querySelector('.oplayhealwrap');
            if (!widgetContainer) return;

            // Create a mutation observer to watch for changes in the widget
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    // Check if the widget content has changed significantly
                    if (mutation.type === 'childList' || mutation.type === 'subtree') {
                        // Small delay to ensure the widget has finished rendering
                        setTimeout(() => {
                            const rect = widgetContainer.getBoundingClientRect();
                            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                            const targetPosition = rect.top + scrollTop - 120;
                            
                            window.scrollTo({
                                top: targetPosition,
                                behavior: 'smooth'
                            });
                        }, 100);
                    }
                });
            });

            // Start observing the widget container
            observer.observe(widgetContainer, {
                childList: true,
                subtree: true,
                attributes: true
            });

            return () => observer.disconnect();
        };

        // Wait for the widget to load
        const timer = setTimeout(observeWidgetChanges, 2000);
        
        return () => clearTimeout(timer);
    }, []);
    return (
        <>
            <SEO
                title={new_seo_title}
                meta={post.yoast_meta}
                description={
                    post.yoast_json_ld[0].wordpress__graph[0].description
                }
            />
            <HeaderMain />
           {/*} <HeroSingle pageTitle={post.title} /> */}
            <HeroSingle pageTitle="Inclusive Kids Classes & Programs" />

            <section className="page-section smallestwdt centersec">
                <div className="container">
                  <div>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: post.content,
                            }}
                        /> 

                  </div>
                   
                    {/* <a
                        href="https://clients.mindbodyonline.com/classic/ws?studioid=916083&stype=-8&sTG=28&sView=week&sLoc=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="wrtsbtn yellowbtn inlinebtn"
                    > */}
                        {/*
                        href={`tel:${post.acf.schools_out_call_number}`}
                        CALL {post.acf.schools_out_call_number} TO LEARN MORE
                       
                        Click here to sign up
                    </a>  */}
              {/*      <div className="oplayhealwrap">
                        <h5 class="bluetxt">Book online</h5>
                        <div
                            className=""
                            style={{ textAlign: "left" }}
                            dangerouslySetInnerHTML={{
                                __html: post.acf.widget_healcode_so,
                            }}
                        />
                    </div> */}
                    <script src="https://elfsightcdn.com/platform.js" async></script>
                    <div
                        className="elfsight-app-608a1573-e13a-4534-8db1-bcdbea328c62"
                        data-elfsight-app-lazy
                    ></div>
                    <div
                        className="elfsight-app-03f67897-97ea-43de-992a-9e32ff842359"
                        data-elfsight-app-lazy
                        style={{ marginTop: "80px" }}
                    ></div>

                    <h3 className="greentxt" style={{ marginTop: "50px" }}>
                        Want to see the full class calendar first?
                        <br />
                        <a className="greentxt" style={{ fontFamily: 'hogfish_demoregular' }}
                            href="/class-schedule" target="_blank" rel="noopener noreferrer">
                            Browse Full Interactive Class Calendar
                        </a>
                    </h3>
{/*
                    <script src="https://static.elfsight.com/platform/platform.js" async></script>
                    <div
                        className="elfsight-app-ddf8e915-4ecc-4600-a8c0-4ac332c1bc77"
                        data-elfsight-app-lazy
                        style={{ marginTop: "80px" }}
                    ></div>   */}
                    <img className="schoolsline hidethis"
                        src={LineFull}
                        alt="linefull"
                    />
                    <div className="hidethis"
                        dangerouslySetInnerHTML={{
                            __html: post.so_sessions_text,
                        }}
                    />
                    <img className="hidethis"
                        src={
                            post.acf.so_program_image.localFile.childImageSharp
                                .fluid.src
                        }
                        alt="schools program"
                    />
                    <img className="schoolsline hidethis"
                        src={LineFull}
                        alt="linefull"
                    />
                    <h2 className="bluetxt hidethis">Check our pricing</h2>
                    <div className="smallestwdt packagesdiv hidethis">
                        {post.acf.so_sessions.map((session, i) => (
                            <div
                                className="pricingbox schoolspricing bg-primary text-white"
                                key={i}
                            >
                                <h3>
                                    <span
                                        className="yellowtxt"
                                        dangerouslySetInnerHTML={{
                                            __html: session.session_title,
                                        }}
                                    />
                                    <br />

                                    {session.session_pricing}
                                </h3>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="whywelist page-section bg-secondary text-white hidesec">
                <div className="container flexwrap bdaytxtadjust">
                    <div className="whylistlft flexbox">
                        <h2
                            className="yellowtxt"
                            dangerouslySetInnerHTML={{
                                __html: post.acf.so_enjoy_title,
                            }}
                        />
                        <p
                            className="biggertxt"
                            dangerouslySetInnerHTML={{
                                __html: post.acf.so_enjoy_content,
                            }}
                        />

                        <h2 className="yellowtxt">
                            CALL {post.acf.schools_out_call_number} TO LEARN
                            MORE
                        </h2>
                    </div>

                    <div className="flexbox">
                        <div className="equipstarimgrgt">
                            <img
                                className="whiteborderimg"
                                src={
                                    post.acf.so_enjoy_image.localFile
                                        .childImageSharp.fluid.src
                                }
                                alt="unlimitedOp"
                            />
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            </Helmet>
        </>
    );
};

export default SchoolsOut;

export const pageQuery = graphql`
    query($id: String!) {
        wordpressPage(id: { eq: $id }) {
            id
            title
            slug
            content
            yoast_meta {
                name
                property
            }
            yoast_title
            acf {
                widget_healcode_so
                schools_out_call_number
                so_sessions_text
                so_enjoy_title
                so_enjoy_content
                so_sessions {
                    session_title
                    session_pricing
                }
                so_program_image {
                    localFile {
                        childImageSharp {
                            fluid {
                                srcWebp
                                src
                            }
                        }
                    }
                }
                so_enjoy_image {
                    localFile {
                        childImageSharp {
                            fluid {
                                srcWebp
                                src
                            }
                        }
                    }
                }
            }
            yoast_json_ld {
                wordpress__graph {
                    description
                }
            }
        }
    }
`;
